export default "__VITE_ASSET__DmZzmyzF__"